module.exports = __webpack_public_path__ + "img/register_image.eccf470e.png";